module.exports = __webpack_public_path__ + "img/heatloss.82c5d760.png";